import React from "react";
import { ReactComponent as Close } from "../../assets/components-icons/close.svg";
import { ReactComponent as Plus } from "../../assets/components-icons/plus.svg";
import { ReactComponent as Minus } from "../../assets/components-icons/minus.svg";
import { CartServerSide } from "../../context/api_response";
import { UserContext } from "../../context/user";
import { DishesContext } from "../../context/dishes";
import increment from "../../strapi/handle_cart_functions/increment_decrement_func/increment_server_side";
import decrement from "../../strapi/handle_cart_functions/increment_decrement_func/decrement_server_side";
import remove from "../../strapi/handle_cart_functions/increment_decrement_func/remove_server_side";
import { ExtraContext } from "../../context/ExtraFunctions";
import { ReactComponent as Edit } from "../../assets/components-icons/edit.svg";
import { CartContext } from "../../context/cart";

 const CartPage = ({ image, Title, history, category, toppings, price_large,price_medium,price_small,get_crust, get_size, id, amount  }) => {
  const {  userInfo } = React.useContext(CartServerSide);
  const {
    handleAlert,
    setGif,
    setEdit,
  } = React.useContext(ExtraContext);
  const { phone_screen } = React.useContext(DishesContext);
  const { user } = React.useContext(UserContext);
  const { increase_item, remove_item, decrease_item } = React.useContext(
    CartContext
  );
  let item = {image, Title, category, toppings, price_large,price_medium,price_small,get_crust, get_size, id, amount};
    return (
                    <div className='col-lg-12' key={id}>
                      <div className='d-flex'>
                      <div className="col-lg-6 p-0 ">
                        <div className="d-flex">
                          <div className="d-flex  flex-column parent-container position-relative  justify-content-center mr-1">
                            <div className="position-absolute div-control d-flex flex-column">
                              <Edit
                                onClick={() => {
                                  setEdit(true);
                                  history.push(
                                    `/pizza-product/${Title}/${category}/${id}`
                                  );
                                }}
                                className="svgAll mt-1 mr-1"
                              />
                              <Close
                                onClick={(e) =>
                                  remove(
                                    e,
                                    user,
                                    userInfo,
                                    item,
                                    handleAlert,
                                    setGif,
                                    remove_item
                                  )
                                }
                                className="svgAll mt-1 mr-1"
                              />
                            </div>

                            <div className="image-container mt-1">
                              <img src={image[0].url} alt={Title} />
                            </div>


                          </div>

                          {!phone_screen && (
                            <div className="col-lg-8 col-8">
                              <div className="d-flex flex-column">

                                <div>
                                  <h5>{Title}</h5>
                                </div>

                                <div>
                                  <span>
                                    Toppings:
                                    <small className="ml-1">
                                      {toppings}
                                    </small>
                                  </span>
                                </div>

                                <div>
                                  <span>
                                    Crust:
                                    <small className="ml-1">
                                      {get_crust === "Thick crust"
                                        ? "Thick crust(+1.15)"
                                        : get_crust}
                                      {get_crust === "" &&
                                        "Original Crust"}
                                    </small>
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    Size: <small> {get_size} </small>
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 d-flex justify-content-around align-items-center">
                          <div>
                            <h5 className='p-1'>
                              <small>€</small>
                              {get_size === "small" && price_small}
                              {get_size === "medium" && price_medium}
                              {get_size === "large" && price_large}
                              {get_size === "" && price_small}
                            </h5>
                          </div>

                          <div className="border-around">
                            <div className="d-flex">
                              <div>
                                <span>{amount}</span>
                              </div>
                              <div>
                                <Plus
                                  onClick={(e) =>
                                    increment(
                                      e,
                                      user,
                                      userInfo,
                                      item,
                                      handleAlert,
                                      setGif,
                                      increase_item
                                    )
                                  }
                                  className="svgAll bg-grey  ml-2"
                                />
                              </div>

                              <div>
                                <Minus
                                  onClick={(e) =>
                                    decrement(
                                      e,
                                      user,
                                      userInfo,
                                      item,
                                      handleAlert,
                                      setGif,
                                      decrease_item
                                    )
                                  }
                                  className="svgAll bg-grey ml-2"
                                />
                              </div>
                            </div>
                          </div>

                      </div>

                      </div>

                      { phone_screen && (
                          <div className="d-block mt-1 mb-1">
                            <div>
                              <h5>{Title}</h5>
                            </div>

                            <div>
                              <span>
                                Toppings:
                                <small className="ml-1">{toppings}</small>
                              </span>
                            </div>

                            <div>
                              <span>
                                Crust:
                                <small className="ml-1">
                                  {get_crust === "Thick crust" &&
                                    "Thick crust(+1.15)"}
                                  {get_crust === "" && "Original Crust"}
                                  {get_crust}
                                </small>
                              </span>
                            </div>

                            <div>
                              <span>
                                Size: <small> {get_size} </small>
                              </span>
                            </div>
                          </div>
                      )}
                      <div className="borderAll borderGrey  mt-1"></div>
                    </div>
    );
}

export {CartPage as default};
